var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.checkLink)?_c('a',{staticClass:"back-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Go Back")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }